import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createVNode as _createVNode } from "vue"

const _hoisted_1 = ["model"]
const _hoisted_2 = { class: "dropdown w-100" }
const _hoisted_3 = ["id", "onClick"]
const _hoisted_4 = ["innerHTML"]
const _hoisted_5 = ["id", "aria-labelledby"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_recursive_taxonomy_group = _resolveComponent("recursive-taxonomy-group")!

  return (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.availableTaxonomyTerms, (taxonomy, slug) => {
    return (_openBlock(), _createElementBlock("div", {
      class: "col-12 col-md-auto filter",
      model: taxonomy,
      key: slug
    }, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("button", {
          class: _normalizeClass(["btn btn-secondary dropdown-toggle w-100", { show: _ctx.toggles[slug] }]),
          type: "button",
          id: _ctx.componentId('TaxField' + slug),
          "data-bs-toggle": "dropdown",
          "aria-expanded": "false",
          onClick: ($event: any) => (_ctx.toggleDropdown($event, slug))
        }, [
          _createElementVNode("span", {
            innerHTML: taxonomy.name
          }, null, 8, _hoisted_4)
        ], 10, _hoisted_3),
        _createElementVNode("ul", {
          id: _ctx.componentId('TaxField' + slug + 'Dropdown'),
          class: _normalizeClass(["dropdown-menu w-100", { show: _ctx.toggles[slug] }]),
          "aria-labelledby": _ctx.componentId('TaxField' + slug)
        }, [
          _createElementVNode("li", null, [
            _createVNode(_component_recursive_taxonomy_group, {
              ref_for: true,
              ref: "recursiveTaxonomyGroup",
              tax: taxonomy,
              slug: slug,
              onUpdateTaxonomy: _ctx.updateTaxonomy
            }, null, 8, ["tax", "slug", "onUpdateTaxonomy"])
          ])
        ], 10, _hoisted_5)
      ])
    ], 8, _hoisted_1))
  }), 128))
}